
import React, { useEffect, useState } from "react"
import { util, pkcs12, pki, asn1 } from "node-forge"
import classNames from "classnames"

const P12Download = ({privateKey, certPems, password}) => {
  const [downloadUrl, setDownloadUrl] = useState(null)
  const [certs, setCerts] = useState([])
  const [cert, setCert] = useState(null)

  useEffect(() => {
      const certs = certPems.map(pem => pki.certificateFromPem(pem))
      setCerts(certs)
      if (certs.length) {
          setCert(certs[0])
      }
  }, [certPems])

  useEffect(() => {
      if (!privateKey|| !cert) {
          return
      }
      const p12Asn1 = pkcs12.toPkcs12Asn1(
        privateKey, cert, password,
        {algorithm: '3des'}
      )
      const p12 = asn1.toDer(p12Asn1).getBytes()
      const p12binary = Uint8Array.from(p12).map((x, i) => p12.charCodeAt(i))

      const blob = new Blob([p12binary], {type: 'application/x-pkcs12'})
      const url = URL.createObjectURL(blob)
      setDownloadUrl(url)
    }, [privateKey, cert, password])

  return (<form onSubmit={e => e.preventDefault()} >
      <div className="form-group">
        <label htmlFor="cert">
            Certificate serial
        </label>
        <select className="custom-select" id="cert" onChange={e => setCert(e.target.value)}>
            { certs.map((cert, i) => 
                <option key={i}>{cert.serialNumber}</option>
            )}
        </select>
      </div>

     <a href={downloadUrl} download="cert.p12" className="btn btn-primary">
        Download auth bundle
     </a>
  </form>)

}

export default P12Download
